module.exports = __webpack_public_path__ + "static/media/table.685b0b19.svg";